import React from 'react';
import { Facebook } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* VideBits Logo */}
            <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="/logo-transparent.svg" 
                alt="VideBits Logo" 
                className="w-8 h-8"
              />
              <h1 className="text-xl font-light text-gray-900">VideBits</h1>
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-videbits-500 shadow-2xl rounded-lg text-center px-6 py-12">
            <div className="mb-4">
              <h1 className="text-2xl text-white mb-6">Privacy Policy</h1>
              
              <div className="text-base px-6 text-videbits-100 text-left space-y-4">
                <p>
                  It is our policy to respect your privacy. Your privacy is important to us, and we are committed to protecting your personal information.
                </p>
                
                <p>
                  We don't share your data. We currently use session cookies for the search and home pages and IP address information to provide web server monitoring, as required by EU law.
                </p>
                
                <p>
                  What data we do store, we'll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.
                </p>
                
                <p>
                  We don't share any information publicly or with third parties, except when required to by law.
                </p>
                
                <p>
                  Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites and cannot accept responsibility or liability for their respective privacy policies.
                </p>
                
                <p>
                  This privacy policy is subject to change without notice and was last updated on {new Date().getFullYear()}. If you have any questions about how we handle user data and personal information, please <a href="/help" className="text-white underline hover:no-underline">contact us</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-1 md:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <a href="/about" className="hover:underline">About</a>
              <a href="/privacy" className="hover:underline">Privacy</a>
              <a href="/terms" className="hover:underline">Terms</a>
              <a href="/help" className="hover:underline">Help</a>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <a
                href="https://www.facebook.com/videbits"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="VideBits on Facebook"
                className="hover:text-gray-900 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <span>© {new Date().getFullYear()} VideBits Ltd</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;